import { useContext } from 'react'
import { ReportHubContext } from './ReportHubContext'

export const useReportHub = () => {
  const context = useContext(ReportHubContext)

  if (context === undefined) {
    throw new Error('useReportHub must be used within a ReportHubProvider')
  }

  return context
}
